import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { esEnvironmentService } from '@examsoft/haste-ui';

import { applyPolyfills, defineCustomElements } from '@examsoft/haste-ui/dist/loader';

applyPolyfills().then(() => {
  defineCustomElements(window);
});

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

let enviromentFinal = environment;

const isAPIV2 = getCookie('apiV2') ? getCookie('apiV2') === 'true' : false;
const showV2Insights = getCookie('showV2Insights') ? getCookie('showV2Insights') === 'true' : false;

enviromentFinal.urls.marsSOReportUrl =
  isAPIV2 || showV2Insights
    ? enviromentFinal.urls.marsSOReportUrlV2
    : enviromentFinal.urls.marsSOReportUrl;

enviromentFinal.urls.marsAssessmentUrl =
  isAPIV2 || showV2Insights
    ? enviromentFinal.urls.marsAssessmentUrlV2
    : enviromentFinal.urls.marsAssessmentUrl;

if (enviromentFinal.production) {
  enableProdMode();
}

esEnvironmentService.init(enviromentFinal).then((data) => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
